export default function Sass_import() {
  return (
    <div>
      <h1>Sass @import</h1>
    </div>
  );
}
